@if (header !== null) {
  <div class="context-header-wrapper k-pos-relative px-3">
    <ng-container [ngTemplateOutlet]="header"></ng-container>
  </div>
}

<div class="context-content-wrapper k-pos-relative">
  @for (item of contextMenuItems; track item) {
    @if (isVisible(item)) {
      <button
        kendoButton
        themeColor="none"
        class="context-item k-d-flex k-border-none k-w-full k-text-start !k-rounded-none"
        [disabled]="!isActived(item)"
        [ngClass]="item.iconColorClass"
        (click)="click(item)"
      >
        <span class="icon-button k-d-flex k-align-items-center">
          <fa-icon class="k-mr-3" [icon]="item.faIcon" size="sm"></fa-icon>
        </span>
        <span [ngClass]="item.iconColorClass ?? ''">{{ item.text }}</span>
      </button>
    }
  }
</div>

@if (footer !== null) {
  <div class="context-footer-wrapper k-pos-relative">
    <ng-container [ngTemplateOutlet]="footer"></ng-container>
  </div>
}
